/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

$('[data-toggle="modal"]').click(function(e) {
    e.preventDefault();
    var target = $($(this).attr('href'));
    target.toggleClass('active');

    if (!target.hasClass('active') && target.find('[data-vimeo-player]').length) {
        target.find('[data-vimeo-player]').attr('src', '');
    }

    if ($('[data-youtube]').length) {
        $('[data-youtube]').each(function() {
            $(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }

    if (target.find($('[id^="vidyard_"]')).length !== 0) {
        var vidSrc = target.find($('.vidyard_iframe')).attr('src').replace('.js', '.html');
        if ($($(e.target)[0]).attr('class') === 'close' || $($(e.target)[0]).attr('class') === 'modal-overlay') {
            target.find($('.vidyard_iframe')).attr('src', vidSrc);
        } else {

        }
    }
});

$('[data-close="modal"]').click(function(e) {
    e.preventDefault();
    $('[data-modal]').removeClass('active');
});

$(document).keyup(function(e){
    if(e.keyCode === 27) {
        $('[data-modal]').removeClass('active');
    }
});
